<script lang="ts" setup>
import { vOnClickOutside } from '@vueuse/components'

const route = useRoute()
const router = useRouter()

const { loadLayout, layoutData } = useLayout()
await loadLayout()

useServerError(!layoutData?.value?.mainMenu)

const {
  open,
  showSubmenu,
  closeNavigation,
  keypress,
  closeSubnavigation,
  toggleSubnavigation,
} = useNavigation()

watch(() => route.query || route.path, () => {
  if (open.value) {
    closeNavigation()
    const mainEl = document.getElementById('main')
    if (mainEl) {
      mainEl.focus()
    }
  }
})

const backdropClick = () => {
  document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }))
}

onMounted(() => {
  document.addEventListener('keydown', keypress)
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', keypress)
  closeNavigation()
})

router.beforeEach(() => {
  showSubmenu.value = null
})
</script>

<template>
  <nav
    v-if="layoutData?.mainMenu?.Items?.length"
    id="navigation"
    class="navigation"
    :class="{ 'navigation--open': open }"
    :aria-label="$t('Main navigation')"
  >
    <NavigationToggle />

    <div
      :class="{ 'backdrop--active': open }"
      class="backdrop navigation__backdrop"
      @click="backdropClick"
    />

    <div class="navigation__panel">
      <NavigationHeader />

      <div class="navigation__content">
        <slot name="navigation_before" />

        <ul class="navigation__list">
          <template v-for="(item, index) in layoutData?.mainMenu?.Items">
            <li
              v-if="item?.Title && item?.Show"
              :key="index"
              v-on-click-outside="() => closeSubnavigation(index)"
              class="navigation__item"
            >
              <button
                v-if="item?.Subnavigation?.length || item?.Richtexts?.length || item?.Banners?.length || !item.Link"
                type="button"
                class="navigation__link"
                aria-haspopup="true"
                :aria-expanded="showSubmenu === index ? 'true' : 'false'"
                :style="{ '--color': item.Color }"
                @click="toggleSubnavigation(index)"
              >
                <span>{{ item.Title }}</span>
                <NuxtIcon name="icon:arrow" />
              </button>
              <AppLink
                v-else-if="item.Link"
                :to="item.Link"
                class="navigation__link"
                :style="`--color: ${item.Color}`"
              >
                <span>{{ item.Title }}</span>
              </AppLink>

              <NavigationPanel
                v-if="item?.Subnavigation?.length || item?.Richtexts?.length || item?.Banners?.length"
                :item="item"
                :index="index"
              />
            </li>
          </template>
        </ul>

        <slot name="navigation_after" />

        <NavigationExtraLinks>
          <template #before>
            <StorePicker class="extra-links__link" />
          </template>
        </NavigationExtraLinks>
      </div>
    </div>
  </nav>
</template>

<style>
  @import url("~layers/components/Navigation/Component.css");

  .navigation {
    a,
    button {
      color: inherit;
    }
  }
</style>
